import { render, staticRenderFns } from "./ClaimEditor.vue?vue&type=template&id=1abcfbc0&scoped=true&"
import script from "./ClaimEditor.vue?vue&type=script&lang=js&"
export * from "./ClaimEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abcfbc0",
  null
  
)

export default component.exports